import { Step } from 'react-joyride';
import { OnboardingStep } from './onboarding.types';

export const onboardingStepToStep = (step: OnboardingStep): Step => ({
    target: step.className ? `.${step.className}` : 'body',
    title: step.title,
    content: step.content,
    placement: step.placement,
    spotlightPadding: step.padding || 10,
    styles: {
        spotlight: {
            borderRadius: step.borderRadius || 0,
        },
    },
    locale: step.buttonText
        ? {
              next: step.buttonText,
          }
        : undefined,
});
